import { useEffect, useState } from "react";
import { metaMessageHistory } from "../../../api/Messages";
import { LoadingDiv, SweetAlertShow } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Master from "../Master";
import { formatToDateTime } from "../../master/FormatToDateTime";
import Pagination from "../../components/Pagination";

export default function MetaWaHistory() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const [filters, setFilters] = useState({
    date_from: new Date().toISOString().split("T")[0],
    date_to: new Date().toISOString().split("T")[0],
    status: "total",
  });

  const getMessageHistory = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value && value !== "total") {
          addUrl += `&${key}=${encodeURIComponent(value)}`;
        }
      });
      const response = await metaMessageHistory(addUrl);
      if (response?.data?.data) {
        setData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getMessageHistory();
  }, [filters]);

  const getStatusClass = (status) => {
    switch (status) {
      case "failed":
        return "danger";
      case "read":
        return "info";
      case "delivered":
        return "success";
      case "sent":
        return "primary";
      case "received":
        return "warning";
      case "pending":
        return "secondary";
      default:
        return "dark";
    }
  };

  const getFailedResponse = (item) => {
    const payload = item?.last_log?.payload;
    if (!payload) {
      return "No failed response found";
    }
    if (typeof payload === "object") {
      return JSON.stringify(payload, null, 2);
    }
    return payload;
  };

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card mb-4">
                      <div className="card-body">
                        <h4 className="text-primary m-0">
                          Meta Whatsapp Message History
                        </h4>
                        <hr />
                        <div className="row mb-4">
                          <div className="col-md-4">
                            <div className="row g-3">
                              <div className="col-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="date_from"
                                    value={filters?.date_from || ""}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        date_from: e.target.value,
                                      })
                                    }
                                  />

                                  <label htmlFor="date_from">Date From</label>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    id="date_to"
                                    value={filters?.date_to || ""}
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        date_to: e.target.value,
                                      })
                                    }
                                  />

                                  <label htmlFor="date_to">Date To</label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-8">
                            <div className="row g-2 align-items-center justify-content-between">
                              {[
                                {
                                  label: "Total",
                                  value: data?.total,
                                  color: "dark",
                                },
                                {
                                  label: "Pending",
                                  value: data?.pending,
                                  color: "secondary",
                                },
                                {
                                  label: "Sent",
                                  value: data?.sent,
                                  color: "primary",
                                },
                                {
                                  label: "Delivered",
                                  value: data?.delivered,
                                  color: "success",
                                },
                                {
                                  label: "Read",
                                  value: data?.read,
                                  color: "info",
                                },
                                {
                                  label: "Failed",
                                  value: data?.failed,
                                  color: "danger",
                                },
                                {
                                  label: "Received",
                                  value: data?.received,
                                  color: "warning",
                                },
                              ].map((item, i) => {
                                const statusValue = item.label.toLowerCase();

                                return (
                                  <div className="col" key={i}>
                                    <div
                                      className={`card cursor-pointer card-body text-center p-2 ${
                                        filters?.status === statusValue
                                          ? `border border-${item.color}`
                                          : ""
                                      }`}
                                      onClick={() =>
                                        setFilters({
                                          ...filters,
                                          status: statusValue,
                                        })
                                      }
                                    >
                                      <h6 className="text-muted m-0">
                                        {item.label}
                                      </h6>

                                      <h3 className={`text-${item.color} m-0`}>
                                        {item.value ?? 0}
                                      </h3>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>

                        {/* ================= TABLE ================= */}
                        <div className="table-responsive">
                          <table className="table table-hover align-middle">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Mobile</th>
                                <th>Datetime</th>
                                <th>Content</th>
                                <th>Response</th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.messages?.data?.length > 0 ? (
                                data.messages.data.map((item, i) => (
                                  <tr key={item?.id ?? i}>
                                    {/* NUMBER */}
                                    <td>{i + 1}</td>
                                    <td>
                                      <div className="text-nowrap">
                                        <strong>{item?.contact?.phone}</strong>
                                      </div>

                                      {item?.contact?.name && (
                                        <small className="text-muted">
                                          {item.contact.name}
                                        </small>
                                      )}
                                    </td>

                                    {/* DATETIME */}
                                    <td className="text-nowrap">
                                      {formatToDateTime(item?.created_at)}
                                    </td>

                                    {/* ================= CONTENT ================= */}
                                    <td
                                      style={{
                                        minWidth: "450px",
                                        maxWidth: "550px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          background: "#efeae2",
                                          borderRadius: "10px",
                                          padding: "12px 14px",
                                          maxWidth: "500px",
                                          whiteSpace: "pre-line",
                                          wordBreak: "break-word",
                                          fontSize: "14px",
                                          lineHeight: "1.5",
                                          boxShadow:
                                            "0 1px 2px rgba(0,0,0,0.08)",
                                        }}
                                      >
                                        {item?.content}
                                      </div>
                                    </td>

                                    {/* ================= RESPONSE ================= */}
                                    <td
                                      style={{
                                        minWidth: "250px",
                                        maxWidth: "450px",
                                      }}
                                    >
                                      <div className="d-flex align-items-center gap-2">
                                        <span
                                          className={`badge bg-label-${getStatusClass(
                                            item?.status,
                                          )}`}
                                        >
                                          {item?.status}
                                        </span>
                                        {item?.status === "failed" && (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger"
                                            title="View Failed Response"
                                            onClick={() =>
                                              setSelectedMessage(item)
                                            }
                                          >
                                            <i className="ri-eye-line"></i>
                                          </button>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5" className="text-center py-4">
                                    No messages found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <Pagination
                            data={data?.messages}
                            setFilters={setFilters}
                            filters={filters}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========================================================= */}
      {/* FAILED MESSAGE DETAILS MODAL */}
      {/* ========================================================= */}

      {selectedMessage && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
          tabIndex="-1"
          onClick={() => setSelectedMessage(null)}
        >
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              {/* MODAL HEADER */}
              <div className="modal-header">
                <h5 className="modal-title text-danger">
                  Failed Message Details
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedMessage(null)}
                ></button>
              </div>

              {/* MODAL BODY */}
              <div className="modal-body">
                <div className="row g-3">
                  {/* MOBILE */}
                  <div className="col-md-6">
                    <strong>Mobile</strong>

                    <div className="mt-1">
                      {selectedMessage?.contact?.phone || "-"}
                    </div>
                  </div>

                  {/* NAME */}
                  <div className="col-md-6">
                    <strong>Name</strong>

                    <div className="mt-1">
                      {selectedMessage?.contact?.name || "-"}
                    </div>
                  </div>

                  {/* TEMPLATE */}
                  <div className="col-md-6">
                    <strong>Template</strong>

                    <div className="mt-1">
                      {selectedMessage?.template_name || "-"}
                    </div>
                  </div>

                  {/* STATUS */}
                  <div className="col-md-6">
                    <strong>Status</strong>

                    <div className="mt-1">
                      <span className="badge bg-label-danger">
                        {selectedMessage?.status}
                      </span>
                    </div>
                  </div>

                  {/* DATETIME */}
                  <div className="col-md-6">
                    <strong>Date & Time</strong>

                    <div className="mt-1">
                      {formatToDateTime(selectedMessage?.created_at)}
                    </div>
                  </div>

                  {/* MESSAGE */}
                  <div className="col-12">
                    <strong>Message</strong>

                    <div
                      className="mt-2"
                      style={{
                        background: "#efeae2",
                        borderRadius: "10px",
                        padding: "14px",
                        whiteSpace: "pre-line",
                        wordBreak: "break-word",
                        fontSize: "14px",
                        lineHeight: "1.5",
                      }}
                    >
                      {selectedMessage?.content}
                    </div>
                  </div>

                  {/* FAILED RESPONSE */}
                  <div className="col-12">
                    <strong>Failed Response</strong>

                    <pre
                      className="mt-2 p-3 bg-light rounded"
                      style={{
                        maxHeight: "400px",
                        overflow: "auto",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        fontSize: "12px",
                        marginBottom: 0,
                      }}
                    >
                      {getFailedResponse(selectedMessage)}
                    </pre>
                  </div>
                </div>
              </div>

              {/* MODAL FOOTER */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setSelectedMessage(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
